import React from "react";

export default function Loader() {
  return (
    /* From Uiverse.io by satyamchaudharydev */
    <div className="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
